import * as b from "protobufjs/minimal.js";
import "./data.js";
const u = "default" in b ? b.default : b;
function y() {
  return { $type: "squareup.sub2.assets.PlanText", planToken: void 0, text: void 0 };
}
const o = {
  $type: "squareup.sub2.assets.PlanText",
  encode(a, r = u.Writer.create()) {
    return a.planToken !== void 0 && r.uint32(10).string(a.planToken), a.text !== void 0 && r.uint32(18).string(a.text), r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = y();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.planToken = e.string();
          continue;
        case 2:
          if (n !== 18)
            break;
          t.text = e.string();
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return o.fromPartial(a ?? {});
  },
  fromPartial(a) {
    const r = y();
    return r.planToken = a.planToken ?? void 0, r.text = a.text ?? void 0, r;
  }
};
function v() {
  return { $type: "squareup.sub2.assets.PlanTextList", planToken: void 0, text: [] };
}
const h = {
  $type: "squareup.sub2.assets.PlanTextList",
  encode(a, r = u.Writer.create()) {
    a.planToken !== void 0 && r.uint32(10).string(a.planToken);
    for (const e of a.text)
      r.uint32(18).string(e);
    return r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = v();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.planToken = e.string();
          continue;
        case 2:
          if (n !== 18)
            break;
          t.text.push(e.string());
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return h.fromPartial(a ?? {});
  },
  fromPartial(a) {
    var e;
    const r = v();
    return r.planToken = a.planToken ?? void 0, r.text = ((e = a.text) == null ? void 0 : e.map((i) => i)) || [], r;
  }
};
function g() {
  return { $type: "squareup.sub2.assets.PlanFeatureText", planToken: void 0, feature: void 0, text: void 0 };
}
const m = {
  $type: "squareup.sub2.assets.PlanFeatureText",
  encode(a, r = u.Writer.create()) {
    return a.planToken !== void 0 && r.uint32(10).string(a.planToken), a.feature !== void 0 && r.uint32(16).int32(a.feature), a.text !== void 0 && r.uint32(26).string(a.text), r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = g();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.planToken = e.string();
          continue;
        case 2:
          if (n !== 16)
            break;
          t.feature = e.int32();
          continue;
        case 3:
          if (n !== 26)
            break;
          t.text = e.string();
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return m.fromPartial(a ?? {});
  },
  fromPartial(a) {
    const r = g();
    return r.planToken = a.planToken ?? void 0, r.feature = a.feature ?? void 0, r.text = a.text ?? void 0, r;
  }
};
function N() {
  return { $type: "squareup.sub2.assets.FeatureImage", feature: void 0, url: void 0 };
}
const P = {
  $type: "squareup.sub2.assets.FeatureImage",
  encode(a, r = u.Writer.create()) {
    return a.feature !== void 0 && r.uint32(8).int32(a.feature), a.url !== void 0 && r.uint32(18).string(a.url), r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = N();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 8)
            break;
          t.feature = e.int32();
          continue;
        case 2:
          if (n !== 18)
            break;
          t.url = e.string();
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return P.fromPartial(a ?? {});
  },
  fromPartial(a) {
    const r = N();
    return r.feature = a.feature ?? void 0, r.url = a.url ?? void 0, r;
  }
};
function F() {
  return { $type: "squareup.sub2.assets.FeatureText", feature: void 0, text: void 0 };
}
const k = {
  $type: "squareup.sub2.assets.FeatureText",
  encode(a, r = u.Writer.create()) {
    return a.feature !== void 0 && r.uint32(8).int32(a.feature), a.text !== void 0 && r.uint32(18).string(a.text), r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = F();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 8)
            break;
          t.feature = e.int32();
          continue;
        case 2:
          if (n !== 18)
            break;
          t.text = e.string();
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return k.fromPartial(a ?? {});
  },
  fromPartial(a) {
    const r = F();
    return r.feature = a.feature ?? void 0, r.text = a.text ?? void 0, r;
  }
};
function q() {
  return { $type: "squareup.sub2.assets.PlanImage", planToken: void 0, url: void 0 };
}
const T = {
  $type: "squareup.sub2.assets.PlanImage",
  encode(a, r = u.Writer.create()) {
    return a.planToken !== void 0 && r.uint32(10).string(a.planToken), a.url !== void 0 && r.uint32(18).string(a.url), r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = q();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.planToken = e.string();
          continue;
        case 2:
          if (n !== 18)
            break;
          t.url = e.string();
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return T.fromPartial(a ?? {});
  },
  fromPartial(a) {
    const r = q();
    return r.planToken = a.planToken ?? void 0, r.url = a.url ?? void 0, r;
  }
};
function R() {
  return {
    $type: "squareup.sub2.assets.FullPagePaywall",
    header: [],
    paragraph: [],
    image: [],
    tierShortname: [],
    tierName: [],
    planName: [],
    learnMoreUrl: []
  };
}
const B = {
  $type: "squareup.sub2.assets.FullPagePaywall",
  encode(a, r = u.Writer.create()) {
    for (const e of a.header)
      m.encode(e, r.uint32(10).fork()).ldelim();
    for (const e of a.paragraph)
      m.encode(e, r.uint32(18).fork()).ldelim();
    for (const e of a.image)
      P.encode(e, r.uint32(26).fork()).ldelim();
    for (const e of a.tierShortname)
      o.encode(e, r.uint32(34).fork()).ldelim();
    for (const e of a.tierName)
      o.encode(e, r.uint32(42).fork()).ldelim();
    for (const e of a.planName)
      o.encode(e, r.uint32(50).fork()).ldelim();
    for (const e of a.learnMoreUrl)
      k.encode(e, r.uint32(58).fork()).ldelim();
    return r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = R();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.header.push(m.decode(e, e.uint32()));
          continue;
        case 2:
          if (n !== 18)
            break;
          t.paragraph.push(m.decode(e, e.uint32()));
          continue;
        case 3:
          if (n !== 26)
            break;
          t.image.push(P.decode(e, e.uint32()));
          continue;
        case 4:
          if (n !== 34)
            break;
          t.tierShortname.push(o.decode(e, e.uint32()));
          continue;
        case 5:
          if (n !== 42)
            break;
          t.tierName.push(o.decode(e, e.uint32()));
          continue;
        case 6:
          if (n !== 50)
            break;
          t.planName.push(o.decode(e, e.uint32()));
          continue;
        case 7:
          if (n !== 58)
            break;
          t.learnMoreUrl.push(k.decode(e, e.uint32()));
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return B.fromPartial(a ?? {});
  },
  fromPartial(a) {
    var e, i, t, n, p, d, c;
    const r = R();
    return r.header = ((e = a.header) == null ? void 0 : e.map((s) => m.fromPartial(s))) || [], r.paragraph = ((i = a.paragraph) == null ? void 0 : i.map((s) => m.fromPartial(s))) || [], r.image = ((t = a.image) == null ? void 0 : t.map((s) => P.fromPartial(s))) || [], r.tierShortname = ((n = a.tierShortname) == null ? void 0 : n.map((s) => o.fromPartial(s))) || [], r.tierName = ((p = a.tierName) == null ? void 0 : p.map((s) => o.fromPartial(s))) || [], r.planName = ((d = a.planName) == null ? void 0 : d.map((s) => o.fromPartial(s))) || [], r.learnMoreUrl = ((c = a.learnMoreUrl) == null ? void 0 : c.map((s) => k.fromPartial(s))) || [], r;
  }
};
function $() {
  return {
    $type: "squareup.sub2.assets.Modal",
    header: [],
    headerTrialOne: [],
    headerTrialOther: [],
    paragraph: [],
    includes: [],
    includedFeatures: [],
    tierShortname: [],
    tierName: [],
    planName: [],
    learnMoreUrl: []
  };
}
const A = {
  $type: "squareup.sub2.assets.Modal",
  encode(a, r = u.Writer.create()) {
    for (const e of a.header)
      o.encode(e, r.uint32(10).fork()).ldelim();
    for (const e of a.headerTrialOne)
      o.encode(e, r.uint32(18).fork()).ldelim();
    for (const e of a.headerTrialOther)
      o.encode(e, r.uint32(26).fork()).ldelim();
    for (const e of a.paragraph)
      m.encode(e, r.uint32(34).fork()).ldelim();
    for (const e of a.includes)
      o.encode(e, r.uint32(42).fork()).ldelim();
    for (const e of a.includedFeatures)
      h.encode(e, r.uint32(50).fork()).ldelim();
    for (const e of a.tierShortname)
      o.encode(e, r.uint32(58).fork()).ldelim();
    for (const e of a.tierName)
      o.encode(e, r.uint32(66).fork()).ldelim();
    for (const e of a.planName)
      o.encode(e, r.uint32(74).fork()).ldelim();
    for (const e of a.learnMoreUrl)
      k.encode(e, r.uint32(82).fork()).ldelim();
    return r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = $();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.header.push(o.decode(e, e.uint32()));
          continue;
        case 2:
          if (n !== 18)
            break;
          t.headerTrialOne.push(o.decode(e, e.uint32()));
          continue;
        case 3:
          if (n !== 26)
            break;
          t.headerTrialOther.push(o.decode(e, e.uint32()));
          continue;
        case 4:
          if (n !== 34)
            break;
          t.paragraph.push(m.decode(e, e.uint32()));
          continue;
        case 5:
          if (n !== 42)
            break;
          t.includes.push(o.decode(e, e.uint32()));
          continue;
        case 6:
          if (n !== 50)
            break;
          t.includedFeatures.push(h.decode(e, e.uint32()));
          continue;
        case 7:
          if (n !== 58)
            break;
          t.tierShortname.push(o.decode(e, e.uint32()));
          continue;
        case 8:
          if (n !== 66)
            break;
          t.tierName.push(o.decode(e, e.uint32()));
          continue;
        case 9:
          if (n !== 74)
            break;
          t.planName.push(o.decode(e, e.uint32()));
          continue;
        case 10:
          if (n !== 82)
            break;
          t.learnMoreUrl.push(k.decode(e, e.uint32()));
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return A.fromPartial(a ?? {});
  },
  fromPartial(a) {
    var e, i, t, n, p, d, c, s, f, x;
    const r = $();
    return r.header = ((e = a.header) == null ? void 0 : e.map((l) => o.fromPartial(l))) || [], r.headerTrialOne = ((i = a.headerTrialOne) == null ? void 0 : i.map((l) => o.fromPartial(l))) || [], r.headerTrialOther = ((t = a.headerTrialOther) == null ? void 0 : t.map((l) => o.fromPartial(l))) || [], r.paragraph = ((n = a.paragraph) == null ? void 0 : n.map((l) => m.fromPartial(l))) || [], r.includes = ((p = a.includes) == null ? void 0 : p.map((l) => o.fromPartial(l))) || [], r.includedFeatures = ((d = a.includedFeatures) == null ? void 0 : d.map((l) => h.fromPartial(l))) || [], r.tierShortname = ((c = a.tierShortname) == null ? void 0 : c.map((l) => o.fromPartial(l))) || [], r.tierName = ((s = a.tierName) == null ? void 0 : s.map((l) => o.fromPartial(l))) || [], r.planName = ((f = a.planName) == null ? void 0 : f.map((l) => o.fromPartial(l))) || [], r.learnMoreUrl = ((x = a.learnMoreUrl) == null ? void 0 : x.map((l) => k.fromPartial(l))) || [], r;
  }
};
function U() {
  return {
    $type: "squareup.sub2.assets.PaywallCard",
    header: [],
    paragraph: [],
    tryOne: [],
    tryOther: [],
    tierShortname: [],
    tierName: [],
    planName: [],
    learnMoreUrl: []
  };
}
const K = {
  $type: "squareup.sub2.assets.PaywallCard",
  encode(a, r = u.Writer.create()) {
    for (const e of a.header)
      m.encode(e, r.uint32(10).fork()).ldelim();
    for (const e of a.paragraph)
      m.encode(e, r.uint32(18).fork()).ldelim();
    for (const e of a.tryOne)
      o.encode(e, r.uint32(26).fork()).ldelim();
    for (const e of a.tryOther)
      o.encode(e, r.uint32(34).fork()).ldelim();
    for (const e of a.tierShortname)
      o.encode(e, r.uint32(42).fork()).ldelim();
    for (const e of a.tierName)
      o.encode(e, r.uint32(50).fork()).ldelim();
    for (const e of a.planName)
      o.encode(e, r.uint32(58).fork()).ldelim();
    for (const e of a.learnMoreUrl)
      k.encode(e, r.uint32(66).fork()).ldelim();
    return r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = U();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.header.push(m.decode(e, e.uint32()));
          continue;
        case 2:
          if (n !== 18)
            break;
          t.paragraph.push(m.decode(e, e.uint32()));
          continue;
        case 3:
          if (n !== 26)
            break;
          t.tryOne.push(o.decode(e, e.uint32()));
          continue;
        case 4:
          if (n !== 34)
            break;
          t.tryOther.push(o.decode(e, e.uint32()));
          continue;
        case 5:
          if (n !== 42)
            break;
          t.tierShortname.push(o.decode(e, e.uint32()));
          continue;
        case 6:
          if (n !== 50)
            break;
          t.tierName.push(o.decode(e, e.uint32()));
          continue;
        case 7:
          if (n !== 58)
            break;
          t.planName.push(o.decode(e, e.uint32()));
          continue;
        case 8:
          if (n !== 66)
            break;
          t.learnMoreUrl.push(k.decode(e, e.uint32()));
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return K.fromPartial(a ?? {});
  },
  fromPartial(a) {
    var e, i, t, n, p, d, c, s;
    const r = U();
    return r.header = ((e = a.header) == null ? void 0 : e.map((f) => m.fromPartial(f))) || [], r.paragraph = ((i = a.paragraph) == null ? void 0 : i.map((f) => m.fromPartial(f))) || [], r.tryOne = ((t = a.tryOne) == null ? void 0 : t.map((f) => o.fromPartial(f))) || [], r.tryOther = ((n = a.tryOther) == null ? void 0 : n.map((f) => o.fromPartial(f))) || [], r.tierShortname = ((p = a.tierShortname) == null ? void 0 : p.map((f) => o.fromPartial(f))) || [], r.tierName = ((d = a.tierName) == null ? void 0 : d.map((f) => o.fromPartial(f))) || [], r.planName = ((c = a.planName) == null ? void 0 : c.map((f) => o.fromPartial(f))) || [], r.learnMoreUrl = ((s = a.learnMoreUrl) == null ? void 0 : s.map((f) => k.fromPartial(f))) || [], r;
  }
};
function O() {
  return { $type: "squareup.sub2.assets.Downgrade" };
}
const E = {
  $type: "squareup.sub2.assets.Downgrade",
  encode(a, r = u.Writer.create()) {
    return r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = O();
    for (; e.pos < i; ) {
      const n = e.uint32();
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return E.fromPartial(a ?? {});
  },
  fromPartial(a) {
    return O();
  }
};
function M() {
  return {
    $type: "squareup.sub2.assets.TrialWelcome",
    header: [],
    paragraph: [],
    chooseAnotherPlanUrl: [],
    image: [],
    tryFeatures: [],
    exclusiveFeatures: [],
    tierName: []
  };
}
const I = {
  $type: "squareup.sub2.assets.TrialWelcome",
  encode(a, r = u.Writer.create()) {
    for (const e of a.header)
      o.encode(e, r.uint32(10).fork()).ldelim();
    for (const e of a.paragraph)
      o.encode(e, r.uint32(18).fork()).ldelim();
    for (const e of a.chooseAnotherPlanUrl)
      o.encode(e, r.uint32(26).fork()).ldelim();
    for (const e of a.image)
      T.encode(e, r.uint32(34).fork()).ldelim();
    for (const e of a.tryFeatures)
      o.encode(e, r.uint32(42).fork()).ldelim();
    for (const e of a.exclusiveFeatures)
      h.encode(e, r.uint32(50).fork()).ldelim();
    for (const e of a.tierName)
      o.encode(e, r.uint32(58).fork()).ldelim();
    return r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = M();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.header.push(o.decode(e, e.uint32()));
          continue;
        case 2:
          if (n !== 18)
            break;
          t.paragraph.push(o.decode(e, e.uint32()));
          continue;
        case 3:
          if (n !== 26)
            break;
          t.chooseAnotherPlanUrl.push(o.decode(e, e.uint32()));
          continue;
        case 4:
          if (n !== 34)
            break;
          t.image.push(T.decode(e, e.uint32()));
          continue;
        case 5:
          if (n !== 42)
            break;
          t.tryFeatures.push(o.decode(e, e.uint32()));
          continue;
        case 6:
          if (n !== 50)
            break;
          t.exclusiveFeatures.push(h.decode(e, e.uint32()));
          continue;
        case 7:
          if (n !== 58)
            break;
          t.tierName.push(o.decode(e, e.uint32()));
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return I.fromPartial(a ?? {});
  },
  fromPartial(a) {
    var e, i, t, n, p, d, c;
    const r = M();
    return r.header = ((e = a.header) == null ? void 0 : e.map((s) => o.fromPartial(s))) || [], r.paragraph = ((i = a.paragraph) == null ? void 0 : i.map((s) => o.fromPartial(s))) || [], r.chooseAnotherPlanUrl = ((t = a.chooseAnotherPlanUrl) == null ? void 0 : t.map((s) => o.fromPartial(s))) || [], r.image = ((n = a.image) == null ? void 0 : n.map((s) => T.fromPartial(s))) || [], r.tryFeatures = ((p = a.tryFeatures) == null ? void 0 : p.map((s) => o.fromPartial(s))) || [], r.exclusiveFeatures = ((d = a.exclusiveFeatures) == null ? void 0 : d.map((s) => h.fromPartial(s))) || [], r.tierName = ((c = a.tierName) == null ? void 0 : c.map((s) => o.fromPartial(s))) || [], r;
  }
};
function W() {
  return {
    $type: "squareup.sub2.assets.TrialExpiring",
    header: [],
    paragraph: [],
    chooseAnotherPlanUrl: [],
    subscribeToKeep: [],
    exclusiveFeatures: [],
    tierName: []
  };
}
const _ = {
  $type: "squareup.sub2.assets.TrialExpiring",
  encode(a, r = u.Writer.create()) {
    for (const e of a.header)
      o.encode(e, r.uint32(10).fork()).ldelim();
    for (const e of a.paragraph)
      o.encode(e, r.uint32(18).fork()).ldelim();
    for (const e of a.chooseAnotherPlanUrl)
      o.encode(e, r.uint32(26).fork()).ldelim();
    for (const e of a.subscribeToKeep)
      o.encode(e, r.uint32(42).fork()).ldelim();
    for (const e of a.exclusiveFeatures)
      h.encode(e, r.uint32(50).fork()).ldelim();
    for (const e of a.tierName)
      o.encode(e, r.uint32(58).fork()).ldelim();
    return r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = W();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.header.push(o.decode(e, e.uint32()));
          continue;
        case 2:
          if (n !== 18)
            break;
          t.paragraph.push(o.decode(e, e.uint32()));
          continue;
        case 3:
          if (n !== 26)
            break;
          t.chooseAnotherPlanUrl.push(o.decode(e, e.uint32()));
          continue;
        case 5:
          if (n !== 42)
            break;
          t.subscribeToKeep.push(o.decode(e, e.uint32()));
          continue;
        case 6:
          if (n !== 50)
            break;
          t.exclusiveFeatures.push(h.decode(e, e.uint32()));
          continue;
        case 7:
          if (n !== 58)
            break;
          t.tierName.push(o.decode(e, e.uint32()));
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return _.fromPartial(a ?? {});
  },
  fromPartial(a) {
    var e, i, t, n, p, d;
    const r = W();
    return r.header = ((e = a.header) == null ? void 0 : e.map((c) => o.fromPartial(c))) || [], r.paragraph = ((i = a.paragraph) == null ? void 0 : i.map((c) => o.fromPartial(c))) || [], r.chooseAnotherPlanUrl = ((t = a.chooseAnotherPlanUrl) == null ? void 0 : t.map((c) => o.fromPartial(c))) || [], r.subscribeToKeep = ((n = a.subscribeToKeep) == null ? void 0 : n.map((c) => o.fromPartial(c))) || [], r.exclusiveFeatures = ((p = a.exclusiveFeatures) == null ? void 0 : p.map((c) => h.fromPartial(c))) || [], r.tierName = ((d = a.tierName) == null ? void 0 : d.map((c) => o.fromPartial(c))) || [], r;
  }
};
function S() {
  return {
    $type: "squareup.sub2.assets.TrialExpired",
    header: [],
    paragraph: [],
    subscribeToKeep: [],
    exclusiveFeatures: [],
    tierName: []
  };
}
const C = {
  $type: "squareup.sub2.assets.TrialExpired",
  encode(a, r = u.Writer.create()) {
    for (const e of a.header)
      o.encode(e, r.uint32(10).fork()).ldelim();
    for (const e of a.paragraph)
      o.encode(e, r.uint32(18).fork()).ldelim();
    for (const e of a.subscribeToKeep)
      o.encode(e, r.uint32(42).fork()).ldelim();
    for (const e of a.exclusiveFeatures)
      h.encode(e, r.uint32(50).fork()).ldelim();
    for (const e of a.tierName)
      o.encode(e, r.uint32(58).fork()).ldelim();
    return r;
  },
  decode(a, r) {
    const e = a instanceof u.Reader ? a : u.Reader.create(a);
    let i = r === void 0 ? e.len : e.pos + r;
    const t = S();
    for (; e.pos < i; ) {
      const n = e.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          t.header.push(o.decode(e, e.uint32()));
          continue;
        case 2:
          if (n !== 18)
            break;
          t.paragraph.push(o.decode(e, e.uint32()));
          continue;
        case 5:
          if (n !== 42)
            break;
          t.subscribeToKeep.push(o.decode(e, e.uint32()));
          continue;
        case 6:
          if (n !== 50)
            break;
          t.exclusiveFeatures.push(h.decode(e, e.uint32()));
          continue;
        case 7:
          if (n !== 58)
            break;
          t.tierName.push(o.decode(e, e.uint32()));
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      e.skipType(n & 7);
    }
    return t;
  },
  create(a) {
    return C.fromPartial(a ?? {});
  },
  fromPartial(a) {
    var e, i, t, n, p;
    const r = S();
    return r.header = ((e = a.header) == null ? void 0 : e.map((d) => o.fromPartial(d))) || [], r.paragraph = ((i = a.paragraph) == null ? void 0 : i.map((d) => o.fromPartial(d))) || [], r.subscribeToKeep = ((t = a.subscribeToKeep) == null ? void 0 : t.map((d) => o.fromPartial(d))) || [], r.exclusiveFeatures = ((n = a.exclusiveFeatures) == null ? void 0 : n.map((d) => h.fromPartial(d))) || [], r.tierName = ((p = a.tierName) == null ? void 0 : p.map((d) => o.fromPartial(d))) || [], r;
  }
};
export {
  E as Downgrade,
  P as FeatureImage,
  k as FeatureText,
  B as FullPagePaywall,
  A as Modal,
  K as PaywallCard,
  m as PlanFeatureText,
  T as PlanImage,
  o as PlanText,
  h as PlanTextList,
  C as TrialExpired,
  _ as TrialExpiring,
  I as TrialWelcome
};
